import { useRef, useEffect, useCallback } from 'react';

// Worker directory
// Worker URLs cannot be variables, see https://webpack.js.org/guides/web-workers/#syntax
// However we can create worker dynamically based on the key :) 
const workers = {
  jsonDiff: () => new Worker(new URL('./jsonDiff.worker.ts', import.meta.url))
}

export function useWorker<T>(key: keyof typeof workers) {
  const workerRef = useRef<Worker | null>(null);

  useEffect(() => {
    try {
      workerRef.current = workers[key]();
    } catch (error) {
      console.error('Error initializing worker:', error);
    }

    return () => {
      workerRef.current?.terminate();
    }
  }, [key]);

  const execute = useCallback((args: any[]) => {
    return new Promise((resolve, reject) => {
      if (!workerRef.current) {
        reject(new Error('Worker not initialized'));
        return;
      }

      const id = Date.now().toString();
      
      const handleMessage = (e: MessageEvent) => {
        const { id: responseId, result, error } = e.data;
        
        if (responseId === id) {
          workerRef.current?.removeEventListener('message', handleMessage);
          
          if (error) {
            reject(new Error(error));
          } else {
            resolve(result);
          }
        }
      };
      
      workerRef.current.addEventListener('message', handleMessage);
      workerRef.current.postMessage({ id, args });
    });
  }, []);

  return { execute };
} 